export function parseNumber(value) {
  if (value === '' || value == null) return null;
  const parsed = Number.parseFloat(String(value).replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : null;
}

export function formatNumber(value, digits = 2) {
  if (value == null || Number.isNaN(value)) return '—';
  const abs = Math.abs(value);
  const places = abs !== 0 && abs < 0.01 ? 4 : abs >= 1000 ? 1 : digits;
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: places,
  });
}
